import { render, staticRenderFns } from "./create-contract-dialog.vue?vue&type=template&id=1894c502&scoped=true"
import script from "./create-contract-dialog.vue?vue&type=script&lang=js"
export * from "./create-contract-dialog.vue?vue&type=script&lang=js"
import style0 from "./create-contract-dialog.vue?vue&type=style&index=0&id=1894c502&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1894c502",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1894c502')) {
      api.createRecord('1894c502', component.options)
    } else {
      api.reload('1894c502', component.options)
    }
    module.hot.accept("./create-contract-dialog.vue?vue&type=template&id=1894c502&scoped=true", function () {
      api.rerender('1894c502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/entries/components/create-contract-dialog.vue"
export default component.exports